import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { closeModal } from "../../../redux/common/actions";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0)
  }
}));

export const CONFIRMATION_MODAL_NAME = "CONFIRMATION_MODAL";

const ConfirmationModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { confirmationModal, modals } = useSelector(
    store => store.CommonReducer
  );

  const handleClose = () => {
    dispatch(closeModal(CONFIRMATION_MODAL_NAME));
  };

  const handleConfirm = () => {
    confirmationModal.confirmCallback();
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={modals[CONFIRMATION_MODAL_NAME] || false}
        onClose={handleClose}
        maxWidth={confirmationModal.maxWidth || "md"}
        fullWidth={confirmationModal.fullWidth}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {confirmationModal.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirmationModal.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {confirmationModal.refuseButtonText || "Ne"}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {confirmationModal.confirmButtonText || "ANo"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmationModal;
